import React, { useEffect, useRef, useState } from 'react';
import { IonIcon } from '@ionic/react';
import { chevronDownOutline } from 'ionicons/icons';

interface Props {
  text: string | null;
  ms: number | null;
  // El modelo todavía está pensando (no empezó a escribir la respuesta).
  thinking: boolean;
}

function formatDuration(ms: number): string {
  const s = Math.max(1, Math.round(ms / 1000));
  return s < 60 ? `${s} s` : `${Math.floor(s / 60)} min ${s % 60} s`;
}

// Lo que pensó el asistente antes de responder, como en ChatGPT o Claude:
// mientras piensa dice "Pensando…"; al terminar queda plegado como
// "Pensó durante 4 s" y se puede abrir para leerlo.
const AiReasoning: React.FC<Props> = ({ text, ms, thinking }) => {
  const [open, setOpen] = useState(false);
  const bodyRef = useRef<HTMLDivElement>(null);

  // Abierto mientras piensa, se va viendo la última parte.
  useEffect(() => {
    if (thinking && open && bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [text, thinking, open]);

  if (!thinking && !text) return null;

  const label = thinking ? 'Pensando…' : ms ? `Pensó durante ${formatDuration(ms)}` : 'Razonamiento';
  return (
    <div className={`ai-reasoning${open ? ' is-open' : ''}`}>
      <button
        type="button"
        className={`ai-reasoning-toggle${thinking ? ' is-thinking' : ''}`}
        onClick={() => setOpen((o) => !o)}
        disabled={!text}
        aria-expanded={open}
      >
        <span>{label}</span>
        {text && <IonIcon icon={chevronDownOutline} className="ai-reasoning-chevron" />}
      </button>
      {open && text && (
        <div ref={bodyRef} className="ai-reasoning-body">
          {text}
        </div>
      )}
    </div>
  );
};

export default AiReasoning;
